/* eslint-disable @typescript-eslint/no-explicit-any */
import moment, { Moment } from 'moment';
import { DE_LOCALE, ES_LOCALE, FR_LOCALE, PT_BR_LOCALE, RU_LOCALE } from '../../../constants/CommonConstants';
type DateObjectType = Moment;

const DATE_FORMAT_YEAR_MONTH_DAY = 'YYYY-MM-DD';
export const getDateFormatted = (date?: DateObjectType, format?: string): string => {
  return date?.format(format ?? 'MM/DD/YYYY') ?? '';
};

export const getMPOFormattedDate = (): { currMPODate: string; nextMPODate: string } => {
  const dateObj = {
    currMPODate: getDateFormatted(moment(new Date()), DATE_FORMAT_YEAR_MONTH_DAY).toString(),
    nextMPODate: getDateFormatted(moment(new Date()).add(1, 'days'), DATE_FORMAT_YEAR_MONTH_DAY).toString(),
  };
  return dateObj;
};
export const getFormattedFromDate = (dateFlag: boolean): { currDate: string; nextDate: string } => {
  const dateObj = {
    currDate: getDateFormatted(moment(new Date()), dateFlag ? 'DD/MM/YYYY' : 'MM/DD/YYYY')
      .toString()
      .split('-')
      .join('/'),
    nextDate: getDateFormatted(moment(new Date()).add(1, 'days'), dateFlag ? 'DD/MM/YYYY' : 'MM/DD/YYYY')
      .toString()
      .split('-')
      .join('/'),
  };
  return dateObj;
};
export const getMPOFormattedDateNew = (date: string): { currMPODate: string } => {
  if (moment(date) < moment(new Date())) {
    const dateObj = {
      currMPODate: getDateFormatted(moment(new Date()), DATE_FORMAT_YEAR_MONTH_DAY).toString(),
    };
    return dateObj;
  } else {
    const dateObj = {
      currMPODate: getDateFormatted(moment(new Date(date)), DATE_FORMAT_YEAR_MONTH_DAY).toString(),
    };
    return dateObj;
  }
};
export const addDaysToDate = (currentDate: string, daysToAdd: number): string => {
  return getDateFormatted(moment(currentDate).add(daysToAdd, 'days'), 'YYYY-MM-DD');
};

export const removePeriods = (date: string, replaceAll?: boolean): string => {
  if (!date) return '';
  return replaceAll ? date.replaceAll('.', '') : date.replace('.,', ',');
};

export const getCustomFormattedDate = (date: any, currentLocale: string) => {
  switch (currentLocale) {
    case FR_LOCALE:
      return removePeriods(date, true);
    case DE_LOCALE:
      return removePeriods(date, false);
    case ES_LOCALE:
    case PT_BR_LOCALE:
    case RU_LOCALE:
      if (date?.charAt(0) !== ' ') {
        return date?.charAt(0)?.toUpperCase() + date?.slice(1);
      } else {
        return date?.charAt(1)?.toUpperCase() + date?.slice(2);
      }

    default:
      return date;
  }
};

export const getFormattedDate = (daysToAdd = 0) => {
  const date = new Date();
  date.setDate(date.getDate() + daysToAdd);
  return date.toISOString().split('T')[0];
};
